import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { StarIcon, SectionDivider } from './Icons';
const testimonials = [{
  name: 'Elena R.',
  age: '48 años',
  image: 'https://cdn.magicpatterns.com/uploads/8m5Ew4Udi7aLhCwrCzSrAy/Elena_R_png.webp',
  quote: 'Pasé de despertarme 4 veces por noche y no poder abrocharme mis jeans favoritos, a dormir 7 horas seguidas y sentirme ligera de nuevo. Lo mejor es que no paso hambre. Entender mis hormonas fue la pieza del puzzle que me faltaba.',
  result: 'Vientre desinflamado en 21 días.'
}, {
  name: 'Silvia R.',
  age: '46 años',
  image: 'https://cdn.magicpatterns.com/uploads/uBNnn4xyqgDPWCLbNMQjT9/Silvia_R..webp',
  quote: "Lo que más me sorprendió no fue bajar de peso, sino que dejé de pelear contra los antojos. Antes, a las 5 de la tarde, mi cuerpo me pedía azúcar como si fuera una droga. Entender cómo gestionar mi insulina con el 'Timing Circadiano' cambió las reglas del juego. Por primera vez en años, yo mando sobre mi comida y no al revés. Me siento en paz.",
  result: 'Adiós ansiedad por el dulce y -4kg de inflamación.'
}, {
  name: 'Raquel M.',
  age: '50 años',
  image: 'https://cdn.magicpatterns.com/uploads/uMmhWn9Ah7q5KbbhyHG4ff/Raquel_M.webp',
  quote: "Pensé que el cansancio era 'el precio de la edad' y que debía resignarme a estar agotada a las 6 de la tarde. Con Paz Hormonal +40 descubrí que mi cortisol estaba por las nubes. Siguiendo el protocolo de desinflamación, mi energía volvió a ser la de mis 30. He vuelto a salir a caminar, a jugar con mis hijos y a tener ganas de hacer planes. No es una dieta, es recuperar tu vida.",
  result: 'Energía estable todo el día y mejor humor.'
}];
export function TestimonialsSection() {
  return <section className="py-8 px-4 md:px-8 bg-brand-creamAlt" data-id="element-220">
      <div className="max-w-3xl mx-auto" data-id="element-221">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8" data-id="element-222">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-charcoal" data-id="element-223">
            Historias Reales. Resultados Reales.
          </h2>
        </motion.div>

        <div className="space-y-6" data-id="element-224">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-2xl shadow-md border-t-4 border-brand-green overflow-hidden" data-id="element-225">
              <div className="flex flex-col sm:flex-row" data-id="element-226">
                <div className="sm:w-48 flex-shrink-0" data-id="element-227">
                  <img src={t.image} alt={t.name} loading="lazy" decoding="async" className="w-full h-48 sm:h-full object-cover" data-id="element-228" />
                </div>
                <div className="p-6 flex flex-col justify-between flex-1" data-id="element-229">
                  <div data-id="element-230">
                    <div className="flex gap-1 text-brand-gold mb-3" data-id="element-231">
                      {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4" data-id="element-232" />)}
                    </div>
                    <p className="text-base text-brand-charcoal/80 italic leading-relaxed" data-id="element-233">
                      "{t.quote}"
                    </p>
                  </div>
                  <div className="mt-4 pt-4 border-t border-brand-creamAlt flex flex-col sm:flex-row sm:items-end sm:justify-between gap-2" data-id="element-234">
                    <div data-id="element-235">
                      <p className="font-bold text-brand-charcoal" data-id="element-236">{t.name}</p>
                      <p className="text-sm text-brand-charcoal/60" data-id="element-237">{t.age}</p>
                    </div>
                    <div className="bg-brand-cream px-3 py-1.5 rounded-full border border-brand-green/20" data-id="element-238">
                      <p className="text-xs font-bold text-brand-green uppercase tracking-wider" data-id="element-239">
                        Resultado: {t.result}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>

        <SectionDivider data-id="element-240" />
      </div>
    </section>;
}